/**
 * This script will be load on bus tour order page.
 * Use
 * depend jquery.bootstrap.wizard plugin
 * https://github.com/1000hz/bootstrap-validator/
 *
 * 大巴报名精灵程序 Wizard
 *
 *
 */
(function ($) {

    $.fn.bustourOrderForm = function (options) {

        var defaults = {

        };

        var settings = $.extend(
            {},
            defaults,
            options
        );

        /**
         * The debug flag
         * @type {boolean}
         */
        var debug = true;

        var spinImage = "<img src=\"/assets/images/ui-anim_basic_16x16.gif\" width=\"16\" height=\"16\" id=\"iconAjaxLoading\">";

        var URL_CHECK_COUPONCODE = "/bustour/checkCouponCode";

        /**
         * Language
         *
         * @type {{}}
         */
        var lang = {
            please_choose_room_type: "请选择房型",
            one_member_limit_hint: "1人参团不能选择:双人大床间,儿童不占床位,三人间",
            kid_must_under_six_year_old: "儿童年龄必须是6岁以下",
            thri_room_member_count: "选择3人间的人数不正确",
            double_room_not_valid: "选择双人大床间的人数不正确",
            parent_kid_same_room: "大人带小孩必须选择同类型房间",
            adult_with_kid_limit: "一个大人携儿童只能订双人间",
            confirm_delete: "确认删除?",
            sending_request: "正在发送请求...",
            sending_order: "正在发送订单",
            room_single_tip: "单人间价格增加",
            room_thir_tip: "三人间中第三张床为小床，只适合14岁以下的儿童",
            room_doub_tip: "双人大床间需要2人",
            error_can_not_get_price: "发生错误.无法获取过夜价格"
        };

        /**
         * The order model
         *
         * @type object
         */
        var orderModel = {
            tgId: null,
            members: null,
            contact: null,
            upStation: {},
            downStation: {},
            trainFromStation: {},
            trainLeaveStation: {},
            hotelBefore: {},
            hotelAfter: {},
            payment: {},
            couponCode: {},
            notification: null,
            marketResearchAnswers: null
        };

        /**
         *
         * @type {string}
         */
        // var bootstrapSelectPluginUrl = "/js/bootstrap-select/bootstrap-select-1.13.2/dist/js/bootstrap-select.min.js";


        /**
         * The current tab
         *
         * @type {null}
         */
        var currentTab = null;

        /**
         * The array container for tab object
         *
         * @type {Array}
         */
        var tabs = [];

        /**
         * The server URL to booking
         *
         * @type {string}
         */
        var entryBooking = "/bustour/order";

        /**
         * The Server URL to preview
         *
         * @type {string}
         */
        var entryPreview = "/bustour/preview";

        /**
         *
         */
        var clog = function (msg) {
            if (debug === true) {
                console.log(msg);
            }
        };


        /**
         * Use plugin to valid each form
         *
         */
        var validForm = function (form) {
            clog("validForm() called. ");
            $.fn.validator.Constructor.FOCUS_OFFSET = 0;
            form.validator("destroy"); // destroy the old validator
            // init
            form.validator(
                {
                    focus: false,

                    // 自定义校验规则
                    custom: {
                        // 房型校验 对应"data-roomrules"
                        roomrules: function ($el) {
                            var retVal = roomRulesValidation($el);
                            if (null !== retVal) {
                                return retVal;
                            }
                        }
                    },

                    // form内字段名对应的校验
                    fields : {
                        "marketResearchAnswer[]" : {
                            validators: {
                                choice: {
                                    min: 1,
                                    max: 3,
                                    message: "请选择1~3项来源"
                                }
                            }
                        }
                    },

                    feedback: {
                        success: "glyphicon-ok",
                        error: "glyphicon-remove"
                    }
                }
            )
                .validator("update") // update the form element that are dynamic added
                .validator("validate"); // run the validate
            if (form.has(".has-error").length > 0) { // check the result
                // handle the invalid form..
                currentTab.removeClass("done");
                return false; // valid failed
            } else {
                currentTab.addClass("done");
                return true; // valid success
            }
        };

        /**
         * 房型校验器
         *
         * @param $el 需要校验的元素
         * @returns {*}
         */
        var roomRulesValidation = function ($el) {
            var roomType = $el.val();
            clog("roomType = " + roomType);
            if (roomType === "-1") {
                return lang.please_choose_room_type;
            }

            // Rule 1:  1人参团不能选择"双人大床间,儿童不占床位,三人间"
            if ($("tr.memberTicketRow").length === 1) {
                // 报名人数=1
                if (roomType === "1" || roomType === "3" || roomType === "5") {
                    return lang.one_member_limit_hint;
                }
            }

            // 如果选择的是儿童床,检查年龄
            if (roomType === "1") {
                var birthday = $el.closest(".memberTicketRow").find("input.member-birthday").val();
                var age = getAge(birthday);
                if (age > 6) {
                    return lang.kid_must_under_six_year_old;
                }
            }

            // 如果选择3人
            if (roomType === "5") {
                //三人间
                var count = $("select.roomTypeSelector option:selected[value=\"5\"]").length;
                var x = count % 3; //必须是3的倍数
                if (x !== 0) {
                    return lang.thri_room_member_count; // not match
                }
            }

            // 选择双人大床间的人数不正确
            if (roomType === "3") {
                var countB = $("select.roomTypeSelector option:selected[value=\"3\"]").length;
                var y = countB % 2;
                if (y !== 0) {
                    return lang.double_room_not_valid; // not match
                }
            }

            //检查大人带小孩情况
            if ($("tr.memberTicketRow").length === 2) {
                var bday = $("input.member-birthday");
                var a = $(bday[0]).val();
                var b = $(bday[1]).val();
                var ageA = getAge(a);
                var ageB = getAge(b);
                if ((ageA >= 18 && ageB <= 6) || (ageA <= 6) && (ageB >= 18)) {
                    // 一个大人带小孩
                    var rooms = $("select.roomTypeSelector");
                    var roomA = $(rooms[0]).val();
                    var roomB = $(rooms[1]).val();
                    if (roomA !== roomB) {
                        return lang.parent_kid_same_room;
                    }
                    // 房间相同
                    if ((roomA !== "3") && roomA !== "4") {
                        return lang.adult_with_kid_limit;
                    }
                }
            }

            // OK, no error message. Return null.
            return null;
        };


        /**
         * 根据生日计算年龄
         * @param birthday e.g.: "1987.07.01"
         */
        var getAge = function (birthday) {
            var bday = $.trim(birthday);
            if (bday.length === 0) {
                return 0;
            }
            bday = bday.replace(/\./g, "-"); // replace all (/g = global) 1980.1.2 to 1980-1-2
            var dot = new Date(bday);
            var today = new Date();
            var age = Math.floor((today - dot) / (365.25 * 24 * 60 * 60 * 1000));
            return age;
        };

        /**
         * Init the add member button
         * 如果url中有人数，则尝试解析。如果解析失败，使用settings里的默认值。
         *
         */
        var initAddMemberButton = function () {
            $("#addNewMemberButton").off().on("click", addNewMember);
            // Add the first member

            var amount;
            var max = 20;
            var min = 1;

            var a = parseInt(getQueryString("adultQuantity"), 0);
            if (isNaN(a)) {
                a = 0;
            }

            var b = parseInt(getQueryString("childQuantity"), 0);
            if (isNaN(b)) {
                b = 0;
            }

            if ( 0 === a && 0 === b) {
               amount = parseInt(settings.memberCount, 0); // init from settings
            } else {
                amount = a + b;
                if (amount > max || amount < min) {
                    amount = 1;
                }
            }

            for (var i = 0; i < amount; i++) {
                addNewMember();
            }
        };

        // check the parameter adultQuantity childQuantity
        var getQueryString = function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        };


        var addNewMember = function () {
            var tpl = $("#manuelTicketMemberTpl").val();
            $("#memberContainer").append(tpl);
            $(".memberDelBtn").last().off().on("click", function () {
                    clog("Remove the current row.");
                    if (confirm(lang.confirm_delete)) {
                        $(this).closest(".memberTicketRow").remove();
                    }
                }
            );
            $(".member-birthday.date-pick").last().datepicker({
                format: "yyyy.m.d",
                language: "zh-CN",
                calendarWeeks: false,
                defaultViewDate: {
                    year: 1980,
                    month: 0,
                    day: 1
                },
                todayHighlight: true
            });

            // add index
            var trIdx = $("td.tr-idx");
            $.each(trIdx, function (idx, td) {
                var n = idx + 1;
                $(td).html("参团人" + n);
            });

        };

        /**
         * Send order to preview
         *
         */
        var sendRequestToPreview = function () {
            clog("send request to preview.");
            $("#preview").html(spinImage + lang.sending_request);
            var url = entryPreview;
            clog("send model to server");
            if (isModelValid()) {
                // data valid
                $.post(url, getModel())
                    .done(function (data) {
                        $("#preview").html(data);
                    }).fail(function (xhr, status, error) {
                    clog("error");
                    clog(xhr);
                    clog(status);
                    clog(error);
                    $("#preview").html("<h1>错误</h1><p>" + error + "</p>");
                }).always(function () {
                    clog("sendRequestToPreview() finished");
                });
            } else {
                // Not valid
                $("#preview").html("<h1>错误</h1><p>数据不完整</p>");
            }
        };

        var isModelValid = function () {
            return true;
        };

        /**
         * send order request to API Server
         *
         */
        var sendRequestToOrder = function () {
            clog("send request to order API");
            var html = "<p>" + lang.sending_order + "</p>" + spinImage;
            $("#orderSubmit").html(html);
            $.post(entryBooking, getModel())
                .done(function (data) {
                    // Show the result.
                    $("#orderSubmit").html(data);
                    // Hidde the "next" and "previous" button
                    $("ul.pager.wizard").remove();
                    $("div.requiredHint").remove();
                    // hide navi
                    $("#bustourOrderFormNavBar").hide();


                }).fail(function (xhr, status, error) {
                    clog("error");
                    clog(xhr);
                    clog(status);
                    clog(error);
                    $("#orderSubmit").html("<h4>错误</h4><p>提交订单失败。</p>");
                }).always(function () {
                    clog("sendRequestToOrder() finished ");
            });
        };

        /**
         *
         */
        var initScheduleForm = function () {
            $("#needTrainTicketCheck").off().on("click", function () {
                $("#bustourTrainTicketContainer").toggle(this.checked);
            });

            $("#needHotelCheck").off().on("click", function () {
                $("#bustourHotelContainer").toggle(this.checked);
            });
        };

        /**
         * Function to load js plugin
         *
         * @param name The name of jQuery plugin. If null, just include.
         * @param url
         * @param success
         */
        /**
        var includePlugin = function (name, url, success) {
            if (null !== name) {
                if ($()[name] || $[name]) {
                    // plugin already included. Do nothing
                    return;
                }
            }
            $.getScript(url, function (data, textStatus, jqxhr) {
                // clog('plugin ' + name + " is included. ");
                success();
            }).done(function (script, textStatus) {

            }).fail(function (jqxhr, settings, exception) {
                clog("Include " + name + " plugin failed. ");
            });
            return;
        };
        */

        /**
         *  include bootstrap selection plugin
         */
        var initSelectPlugin = function () {
            /**
             * event on stations changed
             * 上下车站的额外费用
             */
            var attachBusStationOnChangeEvent = function () {
                $("#busStationUp, #busStationDown").on("change", function (e) {
                    var msgContainer = $(this).closest(".form-group").find(".help-block.with-errors");
                    var msg = "";
                    //检查上下车站额外费用
                    var key = "";
                    switch ($(this).attr("id")) {
                        case "busStationUp":
                            key = "costup";
                            msg = "";
                            break;

                        case "busStationDown":
                            key = "costdown";
                            msg = "";
                            break;

                        default:
                            msg = "错误。无法取得id";
                            break;
                    }
                    msgContainer.html(msg);
                    var option = this.options[this.selectedIndex];
                    var cost = parseInt($(option).data(key), 10);
                    if (cost > 0) {
                        msgContainer.html("费用增加 " + cost + " EUR");
                    }
                    if (cost < 0 ) {
                        msgContainer.html("费用减少 " + Math.abs(cost) + " EUR");
                    }
                });
            };

            /**
             * 获取火车票价格
             * @param object Train station select element
             * @param jquery object Bus station select element
             */
            var queryTrainPrice = function (trainStationId, busStationId, ele, name) {
                var msgContainer = $(ele).closest(".form-group").find(".help-block.with-errors");
                msgContainer.html("");
                var param = {
                    "busStationId": busStationId,
                    "trainStationId": trainStationId
                };
                var path = "/default.php?controller=bustour&action=trainstationcost";
                $.get(path, param, function (data) {
                    msgContainer.html(name + ": " + data.startStationName + " - " + data.endStationName + " " + data.price + " " + data.currency);
                }).fail(function () {
                    msgContainer.html("发生错误");
                });
            };

            var attachTrainStationOnChangeEvent = function () {
                // event on train station changed
                $("#trainUpStation, #trainDownStation").on("change", function (e) {
                    var ele = $(this);
                    var id = ele.attr("id");
                    var busStationId = null;
                    var name = "";
                    switch (id) {
                        case "trainUpStation":
                            busStationId = $("select#busStationUp").val();
                            name = "去程";
                            break;

                        case "trainDownStation":
                            busStationId = $("select#busStationDown").val();
                            name = "回程";
                            break;

                        default:
                            console.error("not Valid id: " + id);
                            return;
                    }
                    queryTrainPrice(this.value, busStationId, this, name);
                });
            };

            var attachHotelOnChangeEvent = function () {
                // Event on hotel changed
                $("#hotelBefore, #hotelAfter").on("change", function () {
                    var ele = $(this);
                    var msgContainer = ele.closest(".form-group").find(".help-block.with-errors");
                    var bustationId = null;
                    var id = ele.attr("id");
                    var msg = "";
                    switch (id) {
                        case "hotelBefore":
                            bustationId = $("select#busStationUp").val();
                            break;

                        case "hotelAfter":
                            bustationId = $("select#busStationDown").val();
                            break;

                        default:
                            msg = "Not valid ID: " + id;
                            break;
                    }
                    msgContainer.html(msg);
                    if ($(this).prop("checked")) {
                        var path = "/default.php?controller=bustour&action=hotelPrice";
                        var param = {
                            busStationId: bustationId
                        };
                        $.get(path, param, function (data) {
                            if (data.hasOwnProperty("singlePrice")) {
                                var msg = "单人增加<strong>" + data.singlePrice + " " + data.singlePriceCurrency + "</strong>";
                                msg += ", 多人增加<strong>" + data.doublePrice + " " + data.doublePriceCurrency + "/每人</strong>";
                                msgContainer.html(msg);
                            }
                        }).fail(function () {
                            // alert(lang.error_can_not_get_price); //发生错误.无法获取过夜价格
                            msgContainer.html(lang.error_can_not_get_price);
                        });
                    } else {
                        // not checked
                    }
                });
            };

            var attachRoomOnChangeEvent = function () {
                // Event on room type changed
                $("select.roomTypeSelector").on("change", function () {
                    var roomType = $(this).val();
                    var fee = $(this).find(":selected").data("fee");
                    var msgContainer = $(this).parent().find(".help-block.with-errors");
                    msgContainer.html("");
                    var msg = "";
                    switch (roomType) {
                        case "2":
                            msg = lang.room_single_tip; //单人间价格增加
                            msg += fee + "欧元/人/晚";
                            break;

                        case "5":
                            msg = lang.room_thir_tip; //三人间中第三张床为小床，只适合14岁以下的儿童。
                            break;

                        case "3":
                            msg = lang.room_doub_tip; //双人大床间需要2人。
                            break;

                        default:
                            msg = "";
                            break;
                    }
                    msgContainer.html(msg);
                });
            };

            var attchAllOnChangeEvents = function () {
                attachBusStationOnChangeEvent();
                attachTrainStationOnChangeEvent();
                attachHotelOnChangeEvent();
                attachRoomOnChangeEvent();
            };
            attchAllOnChangeEvents();
        };

        /**
         * Scroll the screen to top.
         */
        var scrollToHead = function () {
            clog("scrollToHead() called.");

            var offset = $('div#position').offset().top;

            $("html,body").animate(
                {
                    scrollTop: offset
                },
                800,
                "swing",
                function () {
                }
            );
        };


        /**
         * The config for wizard
         *
         * http://vinceg.github.io/twitter-bootstrap-wizard/
         */
        var wizardConfig = {

            nextSelector: "#nextStepButton",

            previousSelector: "#previousStepButton",

            // Fired when plugin is initialized
            onInit: function (tab, navigation, index) {
                clog("onInit() " + index + " called.");
            },

            // Fired when plugin data is shown
            onShow: function (tab, navigation, index) {
                clog("onShow() " + index + " called. ");
            },

            /**
             * Fired when next button is clicked (return false to disable moving to the previous step)

             * @param tab jQuery Object (The <li>  element)
             * @param navigation object
             * @param index int Start with 1
             * @returns {boolean} Return false to cancel to next
             */
            onNext: function (tab, navigation, index) {
                clog("onNext() called.");
                scrollToHead();
                var validResult = false;
                currentTab = tab;
                var selector = "#form" + index;
                clog("searching FORM " + selector);
                var form = $(selector);
                if (0 < form.length) {
                    // found form
                    clog("Found form!");
                    validResult = validForm(form);
                    clog("Form valid result = " + validResult);
                } else {
                    // no form?
                    clog("Can not find FORM " + selector);
                    validResult = true;
                }
                return validResult;
            },

            /**
             * Fired when previous button is clicked (return false to disable moving to the previous step)
             */
            onPrevious: function (tab, navigation, index) {
                clog("onPrevious() " + index + "called. ");
                currentTab = tab;
                currentTab.removeClass("done");
            },

            /**
             * Fired when first button is clicked (return false to disable moving to the first step)
             */
            onFirst: function (tab, navigation, index) {
                clog("OnFirst() " + index + " called.  disabled");
                return false;
            },

            /**
             * Fired when last button is clicked (return false to disable moving to the last step)
             * default: null
             */
            onLast: function (tab, navigation, index) {
                clog("onLast() " + index + "called. disabled");
                return false;
            },

            // fired whe tab is clicked
            onTabClick: function (tab, navigation, index) {
                clog("onTabClick() called. " + index + " click . Disabled. ");
                return false;
            },

            /*
             * Fired when a tab content is shown (return false to disable showing that tab content)
             */
            onTabShow: function (tab, navigation, index) {
                clog("onTabShow() " + index  + " called. ");
                updateOrderModel();
                printModel();
                switch (index) {
                    case -1:
                        clog("index = -1");
                        break;
                    case 0:
                        clog("index = 0");
                        break;
                    case 1:
                        clog("show member form");
                        break;
                    case 2:
                        clog("show schedule");
                        break;
                    case 3:
                        //显示付页面
                        break;
                    case 4:
                        //显示预览页面
                        // send model to preview API
                        scrollToHead();
                        sendRequestToPreview();
                        break;
                    case 5:
                        // send model to booking API
                        scrollToHead();
                        sendRequestToOrder();
                        break;
                    case 6:
                        break;
                    default:
                        break;
                }
            }
        };

        var insertMarketResearch = function () {
            $.getScript(PLUGIN_JQUERY_MARKET_RESEARCH_URL, function () {
                var opt = {};
                $().marketResearch(opt);
            });
        };



        var printModel = function () {
            clog("===============");
            clog(orderModel);
            clog("===============");
        };

        /**
         * Update the order model
         */
        var updateOrderModel = function () {
            clog("updateOrderModel() called.");
            orderModel.tgId = $("input#tgId").val();
            orderModel.members = getMembers();
            orderModel.contact = getContactModel();
            orderModel.notification = $("#notification").val();
            orderModel.upStation = $("#busStationUp").val();
            orderModel.downStation = $("#busStationDown").val();
            orderModel.trainFromStation = getTrainUpStation();
            orderModel.trainLeaveStation = getTrainDownStation();
            orderModel.hotelBefore = getHotelBefore();
            orderModel.hotelAfter = getHotelAfter();
            orderModel.payment = getPayment();
            orderModel.couponCode = getCoupon();
            orderModel.marketResearchAnswers = getMarketResarchAnswers();
            return;
        };


        var getModel = function () {
            updateOrderModel();
            return orderModel;
        };

        /**
         *
         * Return the contact model
         *
         * @returns {{firstname: (*|jQuery), lastname: (*|jQuery), salutation: null, email: (*|jQuery), telephone: (*|jQuery), mobile: (*|jQuery), street: (*|jQuery), number: (*|jQuery), extra: (*|jQuery), country: (*|jQuery), city: (*|jQuery), zipcode: (*|jQuery), notice: (*|jQuery)}}
         */
        var getContactModel = function () {

            var telephone = "";
            if ($("#c_telephone").val().length > 0) {
                telephone = "00" + $("#c_telephonePrefix").val() + " " + $("#c_telephone").val();
            }

            var mobile = "00" + $("#c_mobilePrefix").val() + " " + $("#c_mobile").val();

            return {
                firstname: $("#c_firstname").val(),
                lastname: $("#c_lastname").val(),
                salutation: null,
                email: $("#c_email").val(),
                telephone: telephone,
                mobile:  mobile,
                street: $("#c_street").val(),
                number: $("#c_house_number").val(),
                extra: $("#c_extra").val(),
                country: $("#c_nation").val(),
                city: $("#c_city").val(),
                zipcode: $("#c_zipcode").val(),
                notice: $("#notification").val()
            };
        };

        /**
         *
         */
        var getMembers = function () {
            var members = [];
            var rows = $(".memberTicketRow");
            $.each(rows, function (idx, row) {
                clog("roomType = " + $(row).find("input[name=roomType]").val());
                var tmp = {
                    firstname: $(row).find("input[name=firstname]").val(),
                    lastname: $(row).find("input[name=lastname]").val(),
                    salutation: $(row).find("select[name=salutation]").val(),
                    birthday: $(row).find("input[name=birthday]").val(),
                    nation: $(row).find("input[name=nation]").val(),
                    passport: $(row).find("input[name=passport]").val(),
                    roomType: $(row).find(".roomTypeSelector").val(),
                    notice: $(row).find("input[name=notice]").val(),
                    hotelBefore: getHotelBefore(),
                    hotelAfter: getHotelAfter()
                };
                members.push(tmp);
            });
            return members;
        };

        var getTrainUpStation = function () {
            var ret = null;
            if ($("#bustourTrainTicketContainer").attr("aria-expanded") === "true") {
                ret = $("select#trainUpStation").val();
            }
            return ret;
        };

        /**
         * Get
         */
        var getTrainDownStation = function () {
            var ret = null;
            if ($("#bustourTrainTicketContainer").attr("aria-expanded") === "true") {
                ret = $("select#trainDownStation").val();
            }
            return ret;
        };

        /**
         * Return if hotel before needed.
         *
         * @returns {*}
         */
        var getHotelBefore = function () {
            var ret = null;
            if ($("#bustourHotelContainer").attr("aria-expanded") === "true") {
                ret = $("#hotelBefore").is(":checked");
            }
            clog("hotel before: " + ret);
            return ret;
        };

        /**
         * Return if hotel after need
         * @returns {*}
         */
        var getHotelAfter = function () {
            var ret = null;
            if ($("#bustourHotelContainer").attr("aria-expanded") === "true") {
                ret = $("#hotelAfter").is(":checked");
            }
            clog("hotel after: " + ret);
            return ret;
        };

        /**
         * Get payment checked
         *
         */
        var getPayment = function () {
            clog("payment called ");
            var inputObj = $("input[name=paymentId]:checked");
            var paymentId = null;
            var paymentName = null;
            if (inputObj.length == 1) {
                paymentId = inputObj.val();
                paymentName = inputObj[0].nextSibling.textContent.trim();
            }

            return {
                paymentId: paymentId,
                paymentName: paymentName,
                paymentPara: null
            };
        };

        /**
         *
         */
        var getCoupon = function () {
            return {
                couponCode: $("#couponCodeInput").val()
            };
        };

        /**
         * Scan all checked answers build a data pair model
         *
         * @returns []
         */
        var getMarketResarchAnswers = function () {
            var answers = [];
            var checked = $("input.marketResearchQuestionsInput:checked");
            clog("checked.length=" + checked.length);
            if (checked.length > 0) {
                $.each(checked, function (i, v) {
                    var tmp = {
                        "value": $(v).val(),
                        "label": $(v).data("label")
                    }
                    answers.push(tmp);
                });
            }
            return answers;
        };

        /**
         * Ajax来验证优惠劵号码
         */
        var initCouponCode = function () {
            var ajaxCouponRequest = function () {
                clog("ajaxCouponRequest() called. ")
                var code = $("#couponCodeInput").val();
                var tgId = orderModel.tgId;
                var c = $("#couponCodeStatus"); // container
                c.html("");
                if (code.length > 0) {
                    c.html(spinImage); // show spin
                    $.get(
                        URL_CHECK_COUPONCODE,
                        {
                            "couponcode": code,
                            "tgId": tgId
                        },
                        function (response) {
                            var status = response.status;
                            var html = response.html;
                            if (status !== "3") {
                                // 返回状态非3，即无效或者超过使用次数等错误
                                // 清除输入框，避免提交无效号码
                                $("#couponCodeInput").val("");
                            }
                            c.html(html);//显示测试结果
                        }
                    ).fail(function (data) {
                        // Status not 200. Failed?
                        c.html("<span class='error'>抱歉，发生了错误！</span>");
                    });

                } else {
                    c.html("");
                }
            };
            $("button#useCouponCodeBtn").off().on("click", function () {
                ajaxCouponRequest();
            });
        };


        /**
         *
         */
        var init = function () {

            // start wizard
            $("ul.pager.wizard > li > a").addClass("btn");
            $("ul.pager.wizard > li.next > a").addClass("btn-success");

            initAddMemberButton();

            // init schedule form
            initScheduleForm();

            // use the bootstrap select plugin
            initSelectPlugin();

            initCouponCode();

            $("#rootwizard").bootstrapWizard(wizardConfig);
        };


        init();

        return this;
    };
}(jQuery));


// WEBPACK FOOTER //
// ./resources/assets/js/jquery.bustourOrderForm.js